@if (isLoading) {
  <app-loader></app-loader>
} @else if (dataSource.data.length > 0) {
<div style="width:100%; display:flex; flex-direction: row; justify-content: space-between; align-items: center;">
      <div>
          <h3>Referral Urls</h3>
      </div>
</div>
  <mat-card class="chart-card" *ngIf="dataSource.data.length > 0" style="margin-bottom: 24px;">
  
  <mat-card-content style="position: relative; height: 320px; width: 100%; margin-top: 16px;">
    <canvas #clickChart></canvas>
  </mat-card-content>
</mat-card>

  <div class="user-property-list-table-container">
    
  <div class="mat-elevation-z8 hide-on-mobile">
    <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="agent">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Agent </mat-header-cell>
          <mat-cell *matCellDef="let ref"> 
            {{ ref.agentName || '' }} ({{ ref.agentCode || '' }})
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="url">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Referral Url </mat-header-cell>
          <mat-cell *matCellDef="let ref">
            {{ ref.referralUrl ?? '' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="count">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Clicks </mat-header-cell>
            <mat-cell *matCellDef="let ref"> {{ ref.count ?? '' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Created </mat-header-cell>
            <mat-cell *matCellDef="let ref"> {{ ref.createdAt ?? '' | date: 'MMMM dd, yyyy'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="updated">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Last Updated </mat-header-cell>
            <mat-cell *matCellDef="let ref"> {{ ref.updatedAt ?? '' | date: 'MMMM dd, yyyy'}} </mat-cell>
        </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    
  </div>

  <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
    <mat-card *ngFor="let ref of dataSource.connect() | async" class="mobile-property-card">
      <!-- <mat-card-header> -->
        <!-- <div mat-card-avatar>
          <mat-icon [class.success]="property.isPublished" [class.error]="!property.isPublished">
            {{ property.isPublished ? 'check_circle' : 'cancel' }}
          </mat-icon>
        </div> -->
        <!-- <mat-card-title>{{ ref || '' }} </mat-card-title> -->
        <!-- <mat-card-subtitle>{{ property.address.city }}, {{ property.address.state }} {{ property.address.zipCode }}</mat-card-subtitle> -->
      <!-- </mat-card-header> -->
      <mat-card-content style="text-align: left">
        <div *ngIf="ref.agentCode">Agent ID: {{ ref.agentCode ?? '' }}</div>
        <div *ngIf="ref.referralUrl">Referral URL: {{ ref.referralUrl ?? '' }}</div>
        <div *ngIf="ref.count">Clicks: {{ ref.count ?? '' }}</div>
        <div *ngIf="ref.createdAt">Created: {{ ref.createdAt ?? '' | date: 'MMMM dd, yyyy'}}</div>
        <div *ngIf="ref.updatedAt">Last Updated: {{ ref.updatedAt ?? '' | date: 'MMMM dd, yyyy'}}</div>
      </mat-card-content>
      
    </mat-card>
  </div>
  <mat-paginator 
      #paginator
      [pageSizeOptions]="[5,10, 25, 100]"
      aria-label="Select page of forms">
    </mat-paginator>
  </div>
} @else {
  <p>No W9 forms found</p>
}